

























import { Component, Prop, Vue } from 'vue-property-decorator';
import { MainFooterLayout, MainFooterBlock } from './components';

@Component({
  components: {
    MainFooterLayout,
    MainFooterBlock,
  },
})
export default class ModuleMain extends Vue {
  @Prop({ type: Object, default: () => {} })
  readonly main!: any;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/modules/modulemain/ModuleMain.vue